// @flow
import { b2cPagesService } from '@clubmed/utils';

import { QUOTATION_FORM } from 'Client/cms/toolkit/constants';
import graphQLClient from 'Utils/graphql-client/graphqlClient';
import { LINE_PRODUCT_QUOTATION_FORM } from 'Utils/request/requestDictionary';
import { type ProductQuotationFormLineProps } from 'Components/lines/product-quotation-form-line/ProductQuotationFormLine';

export const productQuotationFormResolver = {
  name: QUOTATION_FORM,
  resolve(
    appContext: AppContext,
    {
      resortId,
      criteria: { dateFormat },
    }: ProductQuotationFormLineProps,
    { pageType }: PageContext,
  ) {
    const isLandingPage = pageType === b2cPagesService.PAGE_TYPES.LANDING;
    const productQuotationFormQuery = `{
      product: resort(productId: "${resortId}") {
        image,
        productId: id
        productLabel: name
        productRangeLabel: rangeLabel
        rangeId
        seasonName
        type
      }
      ${
        isLandingPage
          ? ''
          : `price(productId: "${resortId}") {
        initialPrice { value }
      }`
      }
      bookingCriteria(resortId: "${resortId}") {
        departureCities { value name }
      }
      ${
        isLandingPage
          ? ''
          : `stopover(productId: "${resortId}") {
        tour {
          duration(message: "{durationInNights}")
        }
        extension {
          duration(message: "{durationInNights}")
          title(message: "")
        }
      }`
      }
      tour(productId: "${resortId}") {
        availableDates {
          value
          name: formattedValue(dateFormat: "${dateFormat}")
        }
      }
      civilities { adult { value: code name: label } }
      newsletter(id: CLUBMED) { id description }
      legalInformations { newsletterOptins { id title description } }
    }`;

    return graphQLClient.runQuery(productQuotationFormQuery, appContext, {
      requestName: LINE_PRODUCT_QUOTATION_FORM,
      strictErrors: false,
    });
  },
};
